import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import config from '../../config';
import { useHeaderTitle } from 'src/contexts/HeaderTitleContext';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  [theme.breakpoints.up('xs')]: {
    paddingTop: APP_BAR_DESKTOP + 14,
    paddingLeft: '30px',
    paddingRight: theme.spacing(2),
  },
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  
}));

// ----------------------------------------------------------------------

export default function AdminLayout(props) {
  const [open, setOpen] = useState(false);
  const { headerTitle } = useHeaderTitle();
  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(!open)} headerTitle={headerTitle} open={open}/>

      <Nav openNav={open} onCloseNav={() => setOpen(!open)} />

      <Main>

        {(props.children) ? (
          props.children
        ) : (
          <Outlet />
        )}
      </Main>
    </StyledRoot>
  );
}
